import React from 'react';
import { PageWidth } from '../PageWidth';
import * as classes from './Stage.module.scss';

export interface ISmallProps {
    title: string;
}

export const Small: React.FunctionComponent<ISmallProps> = props => {
    return (
        <div className={classes.small}>
            <PageWidth>
                <h1 className={classes.title}>{props.title}</h1>
            </PageWidth>
        </div>
    );
};
